/**
 * @module lib-bb-widget
 *
 * @description
 * Provides access to the details of the instance of the widget in the
 * portal, such as its ID and preferences.
 *
 * @example
 * // file: index.js
 * import bbWidget from 'lib-bb-widget';
 *
 * const widget = bbWidget(widgetInstance);
 * widget.getPreference('foo');
 *
 */
import widget from './widget';
import adapter from './adapters';
import contextRoot from './context-root';

export default (widgetInstance, Promise) =>
  widget(adapter(widgetInstance), contextRoot(widgetInstance), Promise);



// WEBPACK FOOTER //
// ./lib-bb-widget/scripts/index.js